<template>
    <div class="list-mode-group" aria-hidden="true">
        <input type="radio" id="list-mode-layout_grid" name="list-mode-layout[]" value="grid" data-list-mode="grid"
               v-model="gridMode" tabindex="0">

        <label for="list-mode-layout_grid" class="icon-list-mode list-mode_grid">
            <span class="icons">
                <i class="fa-solid fa-grid" aria-hidden="true"></i>
                <i class="fa-light fa-grid" aria-hidden="true"></i>
            </span>
        </label>

    </div>

    <div class="list-mode-group" aria-hidden="true">
        <input type="radio" id="list-mode-layout_list" name="list-mode-layout[]" value="list" data-list-mode="list"
               v-model="gridMode" tabindex="0">

        <label for="list-mode-layout_list" class="icon-list-mode list-mode_list">
            <span class="icons">
                <i class="fa-regular fa-table-list" aria-hidden="true"></i>
                <i class="fa-light fa-list" aria-hidden="true"></i>
            </span>
        </label>
    </div>
</template>

<script setup>

import { ref, watch, onMounted } from "vue";

//EMIT
const emit = defineEmits( [ "change-layout-mode" ] );

//REF
let gridMode = ref( "" )

//METHODS
function mounted ()
{
    gridMode.value = localStorage.getItem( "amelio.layoutMode" ) ?? "grid";
}

//WATCH
watch( () => gridMode.value, ( newVal, oldVal ) => emit( 'change-layout-mode', newVal ) );


//LIFECYCLE
onMounted( mounted );

</script>

<style scoped>

</style>
